export default "__VITE_ASSET__Cu6n5lLM__"